import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles.css';

// Отдельные панели грузятся лениво — только на своих путях, чтобы не раздувать
// основной бандл клиента.
const App = lazy(() => import('./pages/App').then(m => ({ default: m.App })));
const PartnerApp = lazy(() => import('./pages/PartnerApp').then(m => ({ default: m.PartnerApp })));
const SuperAdminApp = lazy(() => import('./pages/SuperAdminApp').then(m => ({ default: m.SuperAdminApp })));
const VerifyEmailPage = lazy(() => import('./pages/VerifyEmailPage').then(m => ({ default: m.VerifyEmailPage })));
const SsoPage = lazy(() => import('./pages/SsoPage').then(m => ({ default: m.SsoPage })));

const path = window.location.pathname;
const Root = path.startsWith('/partner') ? PartnerApp
  : (path.startsWith('/superadmin') || path.startsWith('/support')) ? SuperAdminApp
  : path.startsWith('/verify-email') ? VerifyEmailPage
  : path.startsWith('/sso') ? SsoPage
  : App;

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <Suspense fallback={<div style={{ padding: 40, fontFamily: 'Inter, system-ui', color: '#5f6b7a' }}>Загрузка…</div>}>
      <Root />
    </Suspense>
  </ErrorBoundary>
);
